import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { IssueByIdDocument, useAppData } from "#app/lib/data";

// Tiny lookup hook for the item ShareDialog header — pulls the issue's
// display name, issue-type icon/name and workflow out of the IssueById
// cache. Lives in lib/hooks/ (Architecture Guard requires Apollo calls
// outside component files); the dialog wrapper just renders.
export function useIssueShareHeader(issueId: string | null) {
  const variables = useMemo(() => ({ issueId: issueId ?? "" }), [issueId]);
  const { data } = useQuery(IssueByIdDocument, {
    variables,
    skip: !issueId,
    fetchPolicy: "cache-first",
  });
  const { workflows } = useAppData();
  const issue = data?.issue;
  const workflowId = issue?.workflowId ?? null;
  const workflowName =
    workflows.find((w) => w.workflowId === workflowId)?.name ?? null;
  return {
    name: issue?.name ?? null,
    issueTypeName: issue?.issueType?.name ?? null,
    // The type's glyph only — types are non-themed, and this icon lands on an
    // `issue` entity whose visual WOULD paint a color.
    icon: issue?.issueType?.icon ? { icon: issue.issueType.icon.icon } : null,
    workflowId,
    workflowName,
  };
}
